import { a as __assign } from '../../tslib.es6-2259bcab.js';
import { c as classNames } from '../../index-444bb648.js';
import * as React from 'react';
import { s as styles } from '../../DataTable.module-c439f136.js';
import { T as TableCell } from '../../index-e3f1c407.js';
import { TableRow } from './TableRow.js';
import '../../ChevronRightIcon-6f867d25.js';
import '../../countries-4c9d3a3b.js';
import '../../index-745ad939.js';
import '../../useId-f6620ea8.js';
import '../../CheckIcon-4d38aabf.js';
import '../../skeleton.module-454f2b7a.js';
import '../../RowContext-2d7a9636.js';
import './Tooltip.js';
import '../../index-7da4a7b7.js';
import 'react-spring';
import 'react/jsx-runtime';
import 'react-dom';
import '../../useOrchard-9169fdc4.js';
import './IconButton.js';
import './TextLink.js';
import './Typography.js';
import '../../ResizeObserver-d8b29c94.js';
import '../../CircleAlertIcon-4e08b678.js';
import '../../CloseIcon-0cca285b.js';
import '../../InfoIcon-ac88a36c.js';
import '../../ThemeProvider-91c278af.js';

function createRow(rowData, columnDefs) {
    return columnDefs.map(function (def, index) {
        var Component = def.component;
        var item = rowData[index];
        return React.createElement(Component, __assign({ key: index }, item));
    });
}
function TableBody(props) {
    var rowsInfo = props.rowsInfo, columnDefs = props.columnDefs;
    var getCellClassNames = React.useCallback(function (column) {
        var _a;
        return classNames((_a = {},
            _a[styles.alignCenter] = columnDefs[column].align === "center",
            _a[styles.alignRight] = columnDefs[column].align === "right",
            _a));
    }, [columnDefs]);
    return (React.createElement("tbody", null, rowsInfo.map(function (row, rowIndex) {
        var cells = createRow(row.data, columnDefs);
        return (React.createElement(TableRow, { key: rowIndex, onClick: row.onClick, rowClassName: row.rowClassName, onMouseEnter: row.onMouseEnter, onMouseLeave: row.onMouseLeave }, cells.map(function (item, columnIndex) { return (React.createElement(TableCell, { key: item.key, className: getCellClassNames(columnIndex) }, item)); })));
    })));
}

export { TableBody };
